import { Box, Button, Checkbox, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import CommonButton from "../CommonButton";
import TimerProjectSelectionModal from "../Timer/TimerProjectSelectionModal";
import { useTimerContext } from "../../contexts/TimerContext";

interface TaskEditBottomContainerProps {
  isCheck: boolean;
  materialStatus: boolean;
  onSaveMaterialStatus: (isCheck: boolean) => {};
  setIsCheck: (isCheck: boolean) => void;
}
const TaskEditBottomContainer: React.FC<TaskEditBottomContainerProps> = ({
  isCheck,
  materialStatus,
  onSaveMaterialStatus,
  setIsCheck,
}) => {
  const theme = useTheme();
  const { selectedProjectForLog, selectedProjectIdForNavigation } = useTimerContext();
  const [isProjectPopup, setIsProjectPopup] = useState(false)
  // useEffect(() => {
  // }, [isCheck]);


  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: "25px" }}>
      <CommonButton
        translationKey={"common.button_opslaan"}
        onClick={() => {
          if (selectedProjectForLog.id === null || (selectedProjectForLog.id !== null && selectedProjectForLog.id !== selectedProjectIdForNavigation)) {
            setIsProjectPopup(true)
          } else {
            onSaveMaterialStatus(isCheck)
          }
        }}
        disabled={materialStatus}
        sx={{
          fontFamily: "Nunito Sans Regular500",
          fontWeight: 700,
          width: "105px",
          mb: "25px",
          backgroundColor: !materialStatus ? "primary.main" : "grey",
          color: theme.palette.secondary.main,
        }}
      />
      {isProjectPopup &&
        <TimerProjectSelectionModal
          handleClose={() => {
            setIsProjectPopup(false)
          }}
          isAnotherProject={selectedProjectForLog.id !== null && selectedProjectForLog.id !== selectedProjectIdForNavigation}
          isVisible={isProjectPopup}
          isDropdownDiabled={true}
        />}
    </Box>
  );
};

export default TaskEditBottomContainer;
